//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import ArticleTeaser from "../article-teaser.vue";

export default {
    props : {
        id : {
            type : String,
            required : true,
            default: ''
        }
    },
    mounted () {
        this.get_more_content()
    },
    methods : {
        get_more_content : function () {
            this.loading = true

            axios
                .get(`/wp-json/vtv/v1/related-posts/get_related`, {
                    params : {
                        id : this.id,
                        offset : this.offset,
                        lang : this.rest_options.lang
                    }
                })
                .then((response) => {
                    /* 
                    Regex /(\d\d)\.(\d\d)\.(\d{4})/ matches a pattern of two digits followed 
                    by a period, then two more digits and another period, and finally 
                    four digits representing day, month, and year.

                    "$1", "$2", and "$3" to reference the three groups of digits matched by the regex. 
                    "$2/$1/$3" re-arranges the groups to represent the desired format of month/day/year. */
                    const regex = [/(\d{1,2})\.(\d{1,2}|\d{2})\.(\d{4})/, "$2/$1/$3"];
                    const responseData = [...response.data].sort((a, b) => {
                        const dateA = new Date(a.date.replace(...regex));
                        const dateB = new Date(b.date.replace(...regex));
                        return dateB - dateA;
                    });
                    return responseData
                }).then((data) => {
                    this.related_posts = this.related_posts.concat(data)
                    this.loading = false;
                    this.offset = this.offset + 3;
                    this.at_maximum = data.length < 3;

                }).catch((error) => {
                    this.loading = false;
                })
        }
    },
    data : function () {
        return {
            related_posts       : [],
            offset              : 0,
            loading             : true,
            rest_options        : rest_options,
            see_all_text        : rest_options.options.translations.see_all,
            at_maximum          : false
        };
    },
    components : {
        ArticleTeaser
    }
}



// WEBPACK FOOTER //
// ./js/vue/people-posts/people-posts.vue